import { createClient } from "./http";
import { env } from "../config/env";

const api = createClient(env.WAREHOUSE_INVENTORY_BASE_URL);
const orderApi = createClient(env.ORDER_BASE_URL);

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export const warehouseCouponsService = {
  async list(params = {}) {
    return api.get("/api/warehouse/coupons", { params: cleanParams(params) });
  },

  async listAdminReadOnly(params = {}) {
    return orderApi.get("/api/orders/warehouse/coupons", { params: cleanParams(params) });
  },

  async create(payload = {}) {
    return api.post("/api/warehouse/coupons", payload);
  },

  async setActive(id, isActive) {
    return api.patch(`/api/warehouse/coupons/${id}/active`, { isActive });
  },
};

export default warehouseCouponsService;
